import React, { useState, useEffect } from "react";
import { Music } from "lucide-react";
import { Button } from "@/src/components/ui/button.tsx";
import { API_ENDPOINTS } from "@/src/config/api.js";

const isYouTubeUrl = (url) => {
    if (!url) return false;
    return /youtube\.com|youtu\.be/i.test(url);
};

const RecentlyPostedTracks = () => {
    const [recentTracks, setRecentTracks] = useState([]);

    useEffect(() => {
        fetch(API_ENDPOINTS.tracks.recent)
            .then(response => response.json())
            .then(data => setRecentTracks(data))
            .catch(error => console.error("Error fetching recent tracks:", error));
    }, []);

    return (
        <div className="bg-neutral-900 rounded-lg p-4">
            <h2 className="font-bold text-lg mb-4">RECENTLY POSTED TRACKS</h2>
            <div className="flex space-x-4 overflow-x-auto pb-4">
                {recentTracks.map((track, i) => (
                    <div key={i} className="flex-shrink-0 w-[150px] group cursor-pointer">
                        <div className="relative">
                            <a href={`/tracks/${track.id}`}>
                                <img
                                    src={isYouTubeUrl(track.sc_url)
                                        ? `https://i3.ytimg.com/vi/${track.media_id}/hqdefault.jpg`
                                        : `https://www.dreamchimney.com/tracks/track_images/${track.id}.jpg`
                                    }
                                    alt={`${track.artist} - ${track.title}`}
                                    className="w-[150px] h-[150px] object-cover rounded-md group-hover:opacity-75 transition-opacity"
                                />
                                <Button
                                    size="icon"
                                    className="absolute bottom-2 right-2 bg-white text-black hover:bg-gray-200 rounded-full w-8 h-8 opacity-0 group-hover:opacity-100 transition-opacity"
                                >
                                    <Music className="h-4 w-4" />
                                </Button></a>
                        </div>
                        <h3 className="text-sm font-bold mt-2 truncate">{track.title}</h3>
                        <p className="text-xs text-gray-400 truncate">{track.artist}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentlyPostedTracks; 